// import React from "react";
// import ProgressBar from "@ramonak/react-progress-bar";
// import "./style.css";

// const CustomProgressBar = (props) => {
//   let { max, fill } = props;
//   console.log(max, "===> max");
//   console.log(fill, " ===> fill");
//   return (
//     <div className="ml-4">
//       <ProgressBar
//         ariaValuemax={max-10  }
//         ariaValuemin={10}

//         completed={40}
//         bgColor="#ffd700"
//         isLabelVisible={false}
//       />
//     </div>
//   );
// };

// export default CustomProgressBar;

import React from "react";
import ProgressBar from "@ramonak/react-progress-bar";
import "./style.css";

const CustomProgressBar = (props) => {
  let { percetile_10, percetile_50, percetile_90 } = props;

  let first = percetile_10 + "%";
  let second = percetile_50 - percetile_10;
  second = second + "%";

  let third = percetile_90 - percetile_50;
  third = third + "%";
  return (
    <div className="mt-4">
      <div className="overflow-hidden h-4 mb-4 text-xs flex  bg-gray-100 shadow-sm">
        <div
          style={{
            width: first,
          }}
          className={`shadow-none flex flex-col py-4 text-center whitespace-nowrap text-white justify-center bg-gray-100`}
        ></div>
        <div
          style={{
            width: second,
          }}
          className={`shadow-none flex flex-col py-4 text-center  text-white justify-center bg-[#FFD700] border-r-4 border-[#007E8C] `}
        ></div>
        <div
          style={{
            width: third,
          }}
          className=" shadow-none flex flex-col py-4 text-center whitespace-nowrap text-white justify-center bg-[#F3AE00]"
        ></div>
      </div>
    </div>
  );
};

export default CustomProgressBar;
